// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingRecipientModalSuggestions-moduleDocFlowMappingRecipientModalSuggestions__KNkGj";
var _2 = "DocFlowMappingRecipientModalSuggestions-modulelist__UVhHl";
export { _1 as "DocFlowMappingRecipientModalSuggestions", _2 as "list" }
